export default __webpack_public_path__ + "static/media/(38).667e6e35.jpg";